<template>
<div class="mall-image-goods-item">
	<el-image :src="data.goodsThumbnail" fit="fill" @click="toDetail(data.goodsId)"></el-image>
	<div class="image-item-info">
		<div class="image-item-info-top">
			<div class="image-item-price">￥{{ goodsPrice(data.goodsPriceType) }}</div>
			<div class="image-item-comment"><span>{{ data.commentNum }}</span>评价</div>
		</div>
		<div class="image-item-name" :title="data.goodsName" @click="toDetail(data.goodsId)">
			{{ data.goodsName }}</div>
		<div class="image-item-info-bottom">
			<el-tag v-if="data.goodsCategory === 2">{{ data.productDistinguishability }}m</el-tag>
			<div>{{ data.createTime }}</div>
		</div>
	</div>
	<div class="image-item-factory" @click="toCompany(data.goodsId)">
		<img src="@/assets/imgs/RemoteSensingMall/imageData/right-icon.png" />
		<span :title="data.shopName">店铺：{{ data.shopName }}</span>
	</div>
</div>
</template>

<script>
export default {
	name: 'GoodsCard',
	props: {
		data: {
			type: Object,
			default: {}
		}
	},
	computed: {
		goodsPrice() {
			return (type) => {
				if(type === 1) {
					return Number(this.data.goodsPrice).toFixed(2)
				}else if(type === 2) {
					return '价格面议'
				}else if(type === 3) {
					return '免费'
				}
				return '价格获取失败'
			}
		}
	},
	methods: {
		toDetail(id) {
			this.$router.push({ name: "productDetail", params: { id: id}})
			// this.$router.push({ name: "shopDetail", query: { goodsId: id}})
		},
		toCompany(id) {
			this.$router.push({path: "/companyInfo", query: { goodsId: id}})
		}
	}
}
</script>

<style lang="scss" scoped>
.mall-image-goods-item {
	display: flex;
	flex-direction: column;
	width: 335px;
	padding: 0 10px;
	padding-top: 20px;
	border-radius: 6px;

	>.el-image {
		width: 100%;
		height: 240px;
		margin: 0;
		padding: 0;
		border-top-left-radius: 6px;
		border-top-right-radius: 6px;
		cursor: pointer;
	}

	>.image-item-info {
		display: flex;
		flex-direction: column;
		padding: 10px 20px;
		background-color: white;

		>.image-item-info-top {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;

			>.image-item-price {
				color: #BD4444;
				font-size: 18px;
			}

			>.image-item-comment {
				color: #999999;
				font-size: 14px;

				>span {
					margin-right: 2px;
					color: #2569F2;
				}
			}
		}

		>.image-item-name {
			margin-top: 20px;
			font-size: 18px;
			font-weight: 600;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			transition: .2s;
			cursor: pointer;

			&:hover {
				opacity: .6;
			}
		}

		>.image-item-info-bottom {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 6px;

			>span {
				height: initial;
				padding: 3px 10px;
				line-height: initial;
			}

			>div {
				color: #999;
				font-size: 14px;
			}
		}
	}

	>.image-item-factory {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
		background-image: linear-gradient(180deg, #ffffff, #E0EAFF);
		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
		color: #2569F2;
		font-size: 14px;
		transition: .3s;
		cursor: pointer;

		&:hover {
			opacity: .7;
		}

		>img {
			margin-right: 10px;
			width: 14px;
			height: 14px;
		}
		> span {
			max-width: 60%;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}
}
</style>